// Colour
const colourSwatch = document.querySelectorAll('.product_colour_swatch[data-colour]');

if (colourSwatch !== null) {
    colourSwatch.forEach((colourSwatch) => {
        const showSwatch = document.querySelector('.show_colour_swatch');
        const colourValue = colourSwatch.getAttribute('data-colour');
        const currValue = showSwatch.getAttribute('data-current-colour');

        colourSwatch.addEventListener('mouseenter', () => {
            showSwatch.textContent = colourValue;
        })

        colourSwatch.addEventListener('mouseleave', () => {
            showSwatch.textContent = currValue;
        })
    })
}

// Size Guide
const sizeGuide = document.querySelector('#size_guide');
const sizeClose = document.querySelector('.popup_size_close');
const sizepopup = document.querySelector('#show_size_guide');
const bodyDisplay = document.querySelector('body');
  
if (sizeGuide !== null) {
    sizeGuide.addEventListener('click', () => {   
        sizepopup.classList.add('active');
        bodyDisplay.classList.add('size_popup_active');
    })
    
    sizeClose.addEventListener('click', () => {
        sizepopup.classList.remove('active');
        bodyDisplay.classList.remove('size_popup_active');
    })
}

// US Men and Women sizes
const genderSizes = document.querySelectorAll('.men-women-sizes button');

if (genderSizes !== null) {
    const menSizes = document.querySelector('.men-size');
    const womenSizes = document.querySelector('.women-size');

    genderSizes.forEach((btn) => {

        btn.addEventListener('click', () => {
            const genderMen = document.querySelectorAll('.gender_men');
            const genderWomen = document.querySelectorAll('.gender_women');

            if (menSizes.classList.contains('selected')) {
                menSizes.classList.remove('selected');
            } else {
                menSizes.classList.add('selected');
                const hideVariant = document.querySelectorAll('.variant-input[data-women]');
                hideVariant.forEach((hide) => {
                    if (hide.getAttribute('data-women') === '0') {
                        hide.style.display = 'block';
                    }
                })
            }

            if (womenSizes.classList.contains('selected')) {
                womenSizes.classList.remove('selected');
            } else {
                womenSizes.classList.add('selected');
                const hideVariant = document.querySelectorAll('.variant-input[data-women]');
                hideVariant.forEach((hide) => {
                    if (hide.getAttribute('data-women') === '0') {
                        hide.style.display = 'none';
                    }
                })
            }

            genderMen.forEach((men) => {
                if (men.classList.contains('hide')) {
                    men.classList.remove('hide');
                } else {
                    men.classList.add('hide');
                }
            })

            genderWomen.forEach((women) => {
                if (women.classList.contains('hide')) {
                    women.classList.remove('hide');
                } else {
                    women.classList.add('hide');
                }
            })

        })
    })
}
